import React, { useEffect, useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { useConnectors } from '../../../providers/connectors/hook/useConnectors';
import { FiltersContainer } from '../styled';
import { DashboardForm, FiltersBlockProps, InputName } from '../types';

import { FilterMetrics } from './FilterMetrics';
import { Filters } from './Filters';
import { MetricsInput } from './MetricsInput';
import { SplitsFilter } from './SplitsFilter';

export const FiltersBlock = ({
  googleAdsMetrics,
  shopifyFilterValues,
  magentoFilterValues,
  connectors,
  ...props
}: FiltersBlockProps) => {
  const { watch } = useFormContext<DashboardForm>();
  const [isShownMetricFilters, setIsShownMetricFilters] =
    useState<boolean>(true);
  const { splits } = useConnectors();

  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));

  const filters = watch(InputName.filters);

  // temporary solution
  const googleAdsMetricId =
    googleAdsMetrics.find(({ category }) => category === 'metric')?.id || '';

  useEffect(() => {
    if (!isShownMetricFilters && !filters.length) setIsShownMetricFilters(true);
  }, [isShownMetricFilters, filters.length]);

  // const { data: shopifyFiltersData } = useQuery<Pick<Query, 'getShopifyFilters'>>(GET_SHOPIFY_FILTERS, {
  //   skip: !connectors?.shopifyConnectorId,
  //   onError,
  // });
  //
  // const shopifySplits: Split[] =
  //   (shopifyFiltersData?.getShopifyFilters ?? [])
  //     .map(({ key }) => ({
  //       key,
  //       label: getTitle(key),
  //       id: key,
  //       connectorType: ConnectorType.SHOPIFY,
  //     }))
  //     .sort((a, b) => a.label.localeCompare(b.label)) || [];

  // const allSplits = [...splits, ...shopifySplits];
  const allSplits = splits;
  // fix duplication shopify splits

  return (
    <FiltersContainer>
      <Box
        display="flex"
        flexDirection="column"
        gap={{ xs: '10px', sm: '15px' }}
        width="100%"
        minWidth={0}
        maxWidth="100%"
        boxSizing="border-box"
        overflow="visible" // Cambiato da 'hidden' a 'visible'
      >
        <Box
          display="flex"
          gap={{ xs: '8px', sm: '15px' }}
          flexDirection={{ xs: 'column', sm: 'row' }}
          flexWrap="wrap"
          minWidth={0}
          maxWidth="100%"
          boxSizing="border-box"
          overflow="visible" // Cambiato da 'hidden' a 'visible'
          alignItems="flex-start" // Aggiunto per allineare correttamente gli elementi
        >
          {isLargeScreen && (
            <>
              <SplitsFilter splits={allSplits} />
              <MetricsInput {...props} />
              <Filters
                shopifyFilterValues={shopifyFilterValues}
                magentoFilterValues={magentoFilterValues}
                toogleFilterMetrics={() =>
                  setIsShownMetricFilters((prev) => !prev)
                }
                isShownMetricFilters={isShownMetricFilters}
                googleAdsMetricId={googleAdsMetricId}
                connectors={connectors}
              />
            </>
          )}
        </Box>
        {isLargeScreen && !!filters.length && isShownMetricFilters && (
          <Box
            display="flex"
            gap={{ xs: '8px', sm: '15px' }}
            flexWrap="wrap"
            flexDirection={{ xs: 'column', sm: 'row' }}
            minWidth={0}
            maxWidth="100%"
            boxSizing="border-box"
            overflow="visible" // Cambiato da 'hidden' a 'visible'
            alignItems="flex-start" // Aggiunto per allineare correttamente gli elementi
          >
            {filters.map((filter, idx) => {
              return (
                <FilterMetrics
                  key={filter.id}
                  filter={filter}
                  formulaItemIndex={idx}
                />
              );
            })}
          </Box>
        )}
      </Box>
    </FiltersContainer>
  );
};
